import React from "react";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import { getCategoryManagementListQuery } from "../../services/graphql/queries/category-management";
import { getAccessPermisionQuery } from "../../services/graphql/queries/accessPermission";
import { getListofGenericMasterQuery } from "../../services/graphql/queries/user";
import { exportProjectsListToCSV } from "../../services/graphql/queries/category-management";
import Pagination from "../Common/Pagination";
import NotAccessible from "../Common/NotAccessible";
import ReactModal from "../Common/ReactModal";

import { errorMessage } from "../../miscellaneous/error-messages";
import { errorMsg } from "../../miscellaneous/react-toastify";

import {
  PAGINATION_OFFSET_VALUE,
  DO_NOT_ACCESS_MESSAGE,
} from "../../constants/app-constants";
import CategoryFilter from "./CategoryFilter";

const CATEGORY_MANAGEMENT_MODULE_ID = 8;
const CATEGORY_MANAGEMENT_FEATURE_ID = 200;

class CategoryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: "",
      pageOfItems: [],
      currentPage: 1,
      offset: PAGINATION_OFFSET_VALUE,

      categoryOption: [],
      showFilter: false,
      isFilterApply: false,
      filterData: {},
      reactModalVisible: false,
      requireCancel: false,
      modalMessage: DO_NOT_ACCESS_MESSAGE,
      accessSpecifier: {},
    };
    this.submitModal = this.submitModal.bind(this);
    this.filterAction = this.filterAction.bind(this);
    this.onFilterData = this.onFilterData.bind(this);
  }

  submitModal() {
    this.setState({ reactModalVisible: false });
  }

  onAddCategory() {
    if (this.state.accessSpecifier.createP) {
      this.props.history.push("/category-add");
    } else {
      this.setState({ reactModalVisible: true });
    }
  }

  onFilterData(data, isFilterApply) {
    this.setState({
      isFilterApply: isFilterApply,
      filterData: data,
      currentPage: 1,
    });
    if (isFilterApply) {
      this.getListOfCategory(this.state.offset, 1, data);
    } else {
      this.setState({
        filterData: {},
      });
      this.getListOfCategory(this.state.offset, 1);
    }
  }

  filterAction() {
    this.setState((prevState) => {
      return {
        showFilter: !prevState.showFilter,
      };
    });
  }

  onChangePage(currentPage) {
    // update state with new page of items
    this.setState(
      {
        currentPage: currentPage,
        loading: true,
      },
      () => {
        if (this.state.isFilterApply) {
          this.getListOfCategory(
            this.state.offset,
            currentPage,
            this.state.filterData
          );
        } else {
          this.getListOfCategory(this.state.offset, currentPage);
        }
      }
    );
  }

  getListOfCategory(id) {
    this.props.client
      .query({
        query: getListofGenericMasterQuery,
        variables: {
          masterFor: id,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var option = result.data.getListofGenericMaster;

        this.initialState = {
          categoryOption: option,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  getListOfCategory(offset, pageNo, data) {
    this.props.client
      .query({
        query: getCategoryManagementListQuery,
        variables: {
          offset: offset,
          pageNo: pageNo,
          id: data && data.id ? data.id : null,
          name: data && data.name ? data.name.trim() : "",
          status: data && data.status ? data.status : null,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var category = result.data.getListOfCategories;

        this.initialState = {
          pageOfItems: category,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  onClickOfExport() {
    this.props.client
      .query({
        query: exportProjectsListToCSV,
        variables: {},
        fetchPolicy: "network-only",
      })
      .then((result) => {
        console.log("csv ", result);
        const base64CSV = result.data?.exportProjectsListToCSV;
        if (base64CSV) {
          const csvBlob = new Blob([atob(base64CSV)], { type: "text/csv" });
          const csvUrl = URL.createObjectURL(csvBlob);
          const a = document.createElement("a");
          a.href = csvUrl;
          a.download = "Project_List.csv";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          console.error("Failed to export CSV");
        }
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });

    this.props.client
      .query({
        query: getAccessPermisionQuery,
        variables: {
          moduleId: CATEGORY_MANAGEMENT_MODULE_ID,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        let response = result.data.getFunctionByModuleId;
        response = JSON.parse(response);
        this.setState({
          accessSpecifier: response[CATEGORY_MANAGEMENT_FEATURE_ID],
        });
        // this.getListOfCategory(15);
        this.getListOfCategory(this.state.offset, this.state.currentPage);
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({
          loading: false,
          error: error.message,
        });
      });
  }

  render() {
    const {
      loading,
      error,
      accessSpecifier,
      reactModalVisible,
      requireCancel,
      modalMessage,
      pageOfItems,
      categoryOption,
    } = this.state;

    if (loading) {
      return <div>Loading...</div>;
    }
    if (error) {
      return <div>{error}</div>;
    }
    return (
      <>
        {accessSpecifier && accessSpecifier.viewP ? (
          <div>
            <ReactModal
              reactModalVisible={reactModalVisible}
              submitModal={this.submitModal}
              modalMessage={modalMessage}
              requireCancel={requireCancel}
            />
            <div className="row align-items-center no-gutters">
              <div className="col-md-8">
                <h1 className="heading m-b-0">Project List</h1>
              </div>
              <div className="col-md-4 text-right">
                <a
                  href="#"
                  className="btn btn-danger"
                  onClick={() => this.onAddCategory()}
                >
                  Add
                </a>
                <button
                  className="btn btn-primary filter-btn  m-l-10"
                  onClick={this.filterAction}
                >
                  Filter
                </button>
                {pageOfItems && pageOfItems.length > 0 && (
                  <a
                    href="#"
                    className="btn btn-danger m-l-10 "
                    onClick={() => this.onClickOfExport()}
                  >
                    Export
                  </a>
                )}
                <CategoryFilter
                  showFilter={this.state.showFilter}
                  filterData={this.state.filterData}
                  listData={this.onFilterData}
                  filterAction={this.filterAction}
                  categoryOption={categoryOption}
                />
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-style-1 m-t-35">
                <thead>
                  <tr>
                    <th style={{ width: "250px" }}>PROJECT ID</th>
                    <th scope="col">NAME</th>
                    <th style={{ width: "150px" }}>DISPLAY ORDER</th>
                    <th style={{ width: "200px" }}>STATUS</th>
                    <th style={{ width: "100px" }}>ACTION(s)</th>
                  </tr>
                </thead>
                <tbody>
                  {pageOfItems.length
                    ? pageOfItems.map((data, index) => {
                        return (
                          <tr key={index}>
                            <td>{data.projectId}</td>
                            <td>{data.name}</td>
                            <td>{data.displayOrder}</td>
                            <td>{data.statusDetail.name}</td>
                            <td>
                              <a
                                href={"/category-detail?id=" + data.id}
                                onClick={() =>
                                  localStorage.setItem("categoryId", data.id)
                                }
                                className="link-primary"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title="View"
                              >
                                <svg
                                  x="0px"
                                  y="0px"
                                  width="16px"
                                  height="16px"
                                  viewBox="0 0 16 16"
                                >
                                  <g transform="translate(0, 0)">
                                    <line
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      x1="4.5"
                                      y1="11.5"
                                      x2="11.5"
                                      y2="11.5"
                                      data-color="color-2"
                                    />
                                    <line
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      x1="4.5"
                                      y1="8.5"
                                      x2="11.5"
                                      y2="8.5"
                                      data-color="color-2"
                                    />
                                    <line
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      x1="4.5"
                                      y1="5.5"
                                      x2="6.5"
                                      y2="5.5"
                                      data-color="color-2"
                                    />
                                    <polygon
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      points="9.5,0.5 1.5,0.5 1.5,15.5 14.5,15.5 14.5,5.5 "
                                    />
                                    <polyline
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      points="9.5,0.5 9.5,5.5 14.5,5.5 "
                                    />
                                  </g>
                                </svg>
                              </a>
                            </td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
            </div>
            {!pageOfItems.length && error ? <div>{error}</div> : null}
            {!pageOfItems.length && loading ? <div>Fetching...</div> : null}
            {!pageOfItems.length && !error && !loading ? (
              <div style={{ textAlign: "center" }}>No Data</div>
            ) : null}
            <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <Pagination
                  loading={loading}
                  items={pageOfItems}
                  pageSize={this.state.offset}
                  initialPage={this.state.currentPage}
                  onChangePage={this.onChangePage.bind(this)}
                />
              </div>
              <div
                className="col-md-2 form-group"
                style={{ display: "flex", marginTop: "8px" }}
              >
                <label style={{ marginTop: "8px" }}>Page Size: </label>
                <select
                  className="form-control"
                  style={{ width: "65px" }}
                  onChange={(e) => {
                    this.setState({ offset: parseInt(e.target.value) }, () => {
                      this.getListOfCategory(
                        this.state.offset,
                        this.state.currentPage
                      );
                    });
                  }}
                >
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={25}>25</option>
                </select>
              </div>
            </div>
          </div>
        ) : (
          <NotAccessible />
        )}
      </>
    );
  }
}
export default withRouter(withApollo(CategoryList));
